/**
 * <DockBody />
 *
 * @parent anybody
 * @children
 * @stateless
 */
import React, { PropTypes } from 'react';
import { Dock } from 'components/UI';
import { confirmable } from 'react-confirm';
import Transition from 'components/UI/Transition';
import { Provider, connect } from 'react-redux'
import _ from 'lodash';
import store from 'root/store';
import Attendance from 'containers/pages/Teacher/Attendance/Attendance'
import VerticalInfoGrid from 'components/UI/VerticalInfoGrid';
import CourseRecord from './CourseRecord'
import ClockTimeTable from './Tables/clockTimeTable'
import TeacherHeader from './TeacherHeader';
import Teacher from 'mediators/Teacher';
import locale from './locale';
import __R, { userCan } from 'containers/__R'
import CreateTeacherModal from 'template/Modals/CreateTeacher'

import {fetchTeacherInfo} from './redux/actions/fetchTeacherInfo'


import {
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

import './style.scss';

const GENDERS = [__('Male', locale), __('Female', locale), __('Others', locale), __('N/A', locale)];


const mapStateToProps = (state) => ({
  user: state.user,
	teacherInfo: state.teacherInfo
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchTeacherInfo: (teacherId, state, callback) => dispatch(fetchTeacherInfo(teacherId, state, callback)),
	};
};


class DockBody extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this.state = {
			selectedIndex: 0,
      teacher: props.teacherData,
      fields: [],
      fetching: false,
    }

		this.onSelectTab = this.onSelectTab.bind(this)
		this.onClickEdit = this.onClickEdit.bind(this)
  }

	componentWillMount(){
    const {id } = this.props;
		this.props.fetchTeacherInfo(id, 'all', () => {
			const newTeacher = new Teacher({ ...this.props.teacherInfo })
			this.setState({
				fetching: false,
				teacher: newTeacher
			})
		})
	}

	onSelectTab(selectedIndex){
		this.setState({selectedIndex})
	}

	onClickEdit() {
    const { teacher } = this.state;
		const convertedTeacher = teacher.toFormData('v1')
		CreateTeacherModal({mode: 'update', data: convertedTeacher, teacherId: teacher.id})
		.then((res) => {
			this.props.fetchTeacherInfo(this.props.id, 'all', () => {
				const newTeacher = new Teacher({ ...this.props.teacherInfo })
				this.setState({
					fetching: false,
					teacher: newTeacher
				})
			})
		})
		.catch(()=>{})
	}

  render() {
		const {isVisible, show, dismiss, mode, id, name} = this.props;
    const {fetching, fields, selectedIndex} = this.state;

    const teacher = this.state.teacher || {};

    let basicInfo = [];

    if (teacher) {
      basicInfo = [
        { label: __('Name', locale), value: teacher.name, },
        { label: __('Gender', locale), value: __(GENDERS[teacher.gender], locale) },
			  { label: __('Phone', locale), value: teacher.phone },
			  { label: __('Email', locale), value: teacher.email },
      ];
    }

    return (
      <Provider store={store}>
        <Dock
          dockStyle={{ minWidth: 760, maxWidth: 880 }}
          className='teacherInfoDock'
          position='right'
          isVisible={show}
          size={0.62}
          overlayOpacity={0.2}
          onCloseDockClick={()=>{
            dismiss();
          }}
          useClosingTag={true}
          dockTitle={
            <TeacherHeader teacher={teacher} onClickEdit={this.onClickEdit} />
          }
          useDefaultCloseButton={false}
        >
            <Transition>
              <Tabs defaultIndex={selectedIndex} onSelect={this.onSelectTab}>
                <TabList>
                  <Tab>{__("Info", locale)}</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_student_class')}>
										{__("Courses", locale)}
									</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_teacher_check_in_record')}>
										{__('Attendance', locale)}
									</Tab>
                  <Tab>{__('Clock Card', locale)}</Tab>
                </TabList>

                <TabPanel>
                  <div className='studentDetail'>
                    <h3>{__('Basic Info', locale)}</h3>
                    <VerticalInfoGrid data={basicInfo} />
                  </div>
                </TabPanel>

                <TabPanel>
									<CourseRecord teacherId={teacher.id} teacherInfo={teacher} />
                </TabPanel>

                <TabPanel>
                  <Attendance state='teacher' teacherId={teacher.id} teacherInfo={teacher} />
                </TabPanel>

                <TabPanel>
                  <ClockTimeTable teacherId={teacher.id} teacherInfo={teacher} />
                </TabPanel>

	            </Tabs>
	          </Transition>
        </Dock>
      </Provider>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(DockBody));



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/DockBody.js